export function setAbortableInterval(interval: number, abortSignal: AbortSignal, callback: () => void) {
	if (abortSignal.aborted) return
	const intervalId = setInterval(callback, interval)
	abortSignal.addEventListener("abort", () => clearInterval(intervalId))
}
